import { useState } from 'react';
import { Button } from '@mui/material';
import CommonListTable, { CommonListColumn } from '../Common/CommonListTable';
import AddIngredientDialog from '../Common/AddIngredientDialog';
import EventBus from '../../EventBus';
import { EventBusEventsEnum } from '../../enums/EventBusEventsEnum';
import { CustomSnackbarTypes } from '../Common/CustomSnackBar';
import ChefForPartyService from '../../services/ChefForPartyService';

const chefForPartyService = new ChefForPartyService();

function ChefForPartyIngredientList(props: any) {
  const [addIngredientModel, setAddIngredientModel] = useState(false);
  const [selectedData, setSelectedData] = useState<any>(null);

  const getOriginalQuantity = (row: any) => {
    if (row?.quantity && Number(row?.quantity) > 0) {
      return `${row.quantity} ${row.unit}`;
    }
    return 'As Needed';
  };

  const getChangedQuantity = (row: any) => {
    if (row?.quantityEdited && Number(row?.quantityEdited) > 0) {
      return `${row.quantityEdited} ${row.unit}`;
    }
    return '-';
  };

  const copyListToClipboard = () => {
    const text = (props?.ingredientList ?? [])
      .map((item: any) => {
        const qty =
          item?.quantityEdited && Number(item?.quantityEdited) > 0
            ? `- ${item.quantityEdited} ${item.unit}`
            : item?.quantity && Number(item?.quantity) > 0
            ? `- ${item.quantity} ${item.unit}`
            : '';
        return `${item?.ingredient_name} ${qty}`.trim();
      })
      .join('\n');

    navigator.clipboard.writeText(text).then(() => {
      EventBus.emitEvent(EventBusEventsEnum.SNACKBAR_SHOW, {
        message: 'All dish information copied to clipboard!',
        type: CustomSnackbarTypes.SUCCESS,
      });
    });
  };

  const columns: CommonListColumn[] = [
    { label: 'Ingredient Name', field: 'ingredient_name' },
    { label: 'Quantity', render: (row) => getOriginalQuantity(row) },
    { label: 'Changed Quantity', render: (row) => getChangedQuantity(row) },
    { label: 'Created At', field: 'createdAt', type: 'datetime' },
    { label: 'Updated At', field: 'updatedAt', type: 'datetime' },
    {
      label: 'Edit',
      stopRowClick: true,
      render: (row) => (
        <Button
          variant="outlined"
          size="small"
          onClick={() => {
            setSelectedData(row);
            setAddIngredientModel(true);
          }}
        >
          Update
        </Button>
      ),
    },
    {
      label: 'Delete',
      stopRowClick: true,
      render: (row) => (
        <Button
          variant="outlined"
          color="error"
          size="small"
          onClick={() => {
            EventBus.emitEvent(EventBusEventsEnum.SHOW_CONFIRMATION_DIALOG, {
              message: 'Are you sure you want to delete this ingredient',
              onClose: (confirmed: boolean) => {
                if (confirmed) {
                  chefForPartyService
                    .updateDeleteIngredient(row?.party_id, {
                      ingredients: [{ id: row?.id, flag: 'DELETE' }],
                    })
                    .then(() => {
                      EventBus.emitEvent(EventBusEventsEnum.SNACKBAR_SHOW, {
                        message: 'Removed successfully',
                        type: CustomSnackbarTypes.SUCCESS,
                      });
                      window.location.reload();
                    });
                }
              },
              title: 'Confirmation',
            });
          }}
        >
          Delete
        </Button>
      ),
    },
  ];

  return (
    <>
      <CommonListTable
        title="Ingredients"
        headerRight={
          <Button variant="outlined" size="small" onClick={copyListToClipboard}>
            Copy List
          </Button>
        }
        columns={columns}
        data={props?.ingredientList ?? []}
        loading={false}
        rowKey={(row) => row?.id}
        emptyText="No Ingredient List Available"
      />

      {addIngredientModel && (
        <AddIngredientDialog
          open={addIngredientModel}
          callback={() => setAddIngredientModel(false)}
          data={selectedData}
          type="update"
        />
      )}
    </>
  );
}

export default ChefForPartyIngredientList;
